export default "__VITE_ASSET__Btf$ASCn__"